<div *ngIf="isContract()">
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "generalOptions.title" | translate }}
  </span>
</div>

<div
  class="flex justify-between py-2 text-sm"
  *ngIf="!isContract()">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.email" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.email }}
  </span>
</div>

<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.formula" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.formulasAndOptionsInformations.formulaName ?? "-" }}
  </span>
</div>

<div
  class="flex justify-between py-2 text-sm"
  *ngIf="!isContract()">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "contractCard.effectiveDate" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.effectiveStartDate | date: "dd/MM/yyyy" }}
  </span>
</div>

<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.care" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ (details.formulasAndOptionsInformations.repaymentPercentage ?? "-") + " %" }}
  </span>
</div>
<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.annualLimit" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ (details.formulasAndOptionsInformations.repaymentLimit | currency: "EUR" : "symbol" : "1.0-0" : "fr") ?? "- €" }}
  </span>
</div>
